import { render, staticRenderFns } from "./MenuBubble.vue?vue&type=template&id=190f543d&scoped=true&"
import script from "./MenuBubble.vue?vue&type=script&lang=js&"
export * from "./MenuBubble.vue?vue&type=script&lang=js&"
import style0 from "./MenuBubble.vue?vue&type=style&index=0&id=190f543d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190f543d",
  null
  
)

export default component.exports